module.exports = __webpack_public_path__ + "media/images/ac_templates/201/wht-d61972ed94c737d2123f940aa2367c1b.jpg";